// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1AF-1","col":"styles_col__2QePP"};